export const professionOptions = [
    { value: null, label: "Seleccione una profesión" },
    { value: "albañil", label: "Albañil" },
    { value: "ingeniero civil", label: "Ingeniero civil" },
    { value: "arquitecto", label: "Arquitecto" },
    { value: "maestro de obras", label: "Maestro de obras" },
    { value: "gerente", label: "Gerente" },
    { value: "distribuidor", label: "Distribuidor" },
    { value: "comerciante", label: "Comerciante" },
    { value: "otros", label: "Otros" },
  ];